import { render, staticRenderFns } from "./NewDuixiang.vue?vue&type=template&id=ea34dab8&scoped=true&"
import script from "./NewDuixiang.vue?vue&type=script&lang=js&"
export * from "./NewDuixiang.vue?vue&type=script&lang=js&"
import style0 from "./NewDuixiang.vue?vue&type=style&index=0&id=ea34dab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea34dab8",
  null
  
)

component.options.__file = "NewDuixiang.vue"
export default component.exports